import React from 'react';
import type { FC } from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const wrapperStyle = css({
	marginBottom: token('space.200'),
});

const cardSkeletonStyle = css({
	background: token('color.skeleton'),
	height: '140px',
	width: '100%',
	marginBottom: token('space.200'),
	borderRadius: token('radius.large'),
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		transition: 'none',
	},
});

/**
 * Loading skeleton for the Meetings panel — a small stack of card placeholders.
 */
export const MeetingsSkeleton: FC = () => (
	<div css={wrapperStyle} data-testid="meetings-skeleton">
		<div css={cardSkeletonStyle} data-testid="meetings-skeleton-card" />
		<div css={cardSkeletonStyle} data-testid="meetings-skeleton-card" />
	</div>
);
